import ResizeObserver from './ResizeObserver.vue';

export default ResizeObserver;
